@if (videoData) {
  @if (videoData.video_type.toLowerCase() === 'youtube') {
    <div
      #iframe
      class="video-player__embed"
      [id]="'youtube-player-' + videoData.id"
    ></div>
  } @else {
    <iframe
      #iframe
      class="video-player__embed"
      [src]="sanitizer.bypassSecurityTrustResourceUrl(videoData.video_url)"
      frameborder="0"
      webkitAllowFullScreen
      mozallowfullscreen
      allowFullScreen
      allow="autoplay"
    ></iframe>
  }
}

<div class="video-player__overlay" [ngClass]="{ '--visible': videoCompleted }">
  <p class="overlay__text">
    {{
      endOfPlaylist
        ? ('video_player_watched_end_of_lesson' | translate)
        : ('video_player_watched' | translate)
    }}
  </p>
  <div class="overlay__actions">
    <button
      mat-stroked-button
      class="overlay__btn--xs-hidden-label"
      (click)="replayVideo()"
    >
      <mat-icon>replay</mat-icon>
      {{ 'Replay_video' | translate }}
    </button>

    @if (endOfPlaylist) {
      @if (hasNextLesson) {
        <button mat-stroked-button click)="openNextLesson()">
          <mat-icon>video_library</mat-icon>
          {{ 'Next_lesson' | translate }}
        </button>
      }
      @if (hasLearningArea) {
        <button mat-flat-button click)="tabChange.emit(1)">
          <mat-icon>quiz</mat-icon>
          {{ 'Excercise_tasks' | translate }}
        </button>
      }
    } @else {
      <button mat-flat-button (click)="playNextVideo()">
        <mat-icon>play_circle</mat-icon>
        {{ 'Next_video' | translate }}
      </button>
    }
  </div>
</div>

<!-- <div class="video-player__overlay" [ngClass]="{ '--visible': videoCompleted }">
  @if (endOfPlaylist) {
    <p class="overlay__text">
      {{ 'video_player_watched_end_of_lesson' | translate }}
    </p>
    <div class="overlay__actions">
      <button
        mat-stroked-button
       
        class="overlay__btn--xs-hidden-label"
        (click)="replayVideo()"
      >
        <mat-icon>replay</mat-icon>
        {{ 'Replay_video' | translate }}
      </button>
      @if (hasNextLesson) {
        <button
          mat-stroked-button
         
          class=""
          (click)="openNextLesson()"
        >
          <mat-icon>video_library</mat-icon>
          {{ 'Next_lesson' | translate }}
        </button>
      }
      @if (hasLearningArea) {
        <button
          mat-flat-button
         
          class=""
          (click)="tabChange.emit(1)"
        >
          <mat-icon>quiz</mat-icon>
          {{ 'Excercise_tasks' | translate }}
        </button>
      }
    </div>
  } @else {
    <p class="overlay__text">{{ 'video_player_watched' | translate }}</p>
    <div class="overlay__actions">
      <button
        mat-stroked-button
       
        class="overlay__btn--xs-hidden-label"
        (click)="replayVideo()"
      >
        <mat-icon>replay</mat-icon>
        {{ 'Replay_video' | translate }}
      </button>
      <button
        mat-flat-button
       
        class=""
        (click)="playNextVideo()"
      >
        <mat-icon>play_circle</mat-icon>
        {{ 'Next_video' | translate }}
      </button>
    </div>
  }
</div> -->
